import { defineCatalogue } from '../../../i18n';

export const homeCatalogue = defineCatalogue(
  {
    'section.campaigns': 'Campanhas',
    'card.noWindow': 'Sem período definido',
    'card.window': '{from} – {to}',
    'empty.title': 'Nenhuma campanha ainda',
    'empty.body': 'Uma campanha reúne as contas que você quer acompanhar.',
    'counts.line': '{campaigns} · {members}',
    'counts.campaigns.other': '{count} campanhas',
    'counts.campaigns.one': '{count} campanha',
    'counts.members.other': '{count} pessoas com acesso',
    'counts.members.one': '{count} pessoa com acesso',
    'newCampaign.noSlot': 'Sem vaga livre para uma nova campanha.',
    'status.collecting': 'Coletando',
    'status.paused': 'Pausada',
    'status.archived': 'Encerrada',
    'filter.label': 'Filtrar campanhas por situação',
    'filter.all': 'Todas',
    'filter.empty': 'Nenhuma campanha nesta situação.',
    'figure.accounts': 'Contas monitoradas',
    'figure.reach': 'Alcance · 7d',
    'figure.posts': 'Publicações · 7d',
    'chart.label': 'Visualizações por dia nos últimos 7 dias',
    'chart.views': 'Visualizações',
    'chart.posts': 'Publicações',
    'chart.noAccounts': 'Adicione contas para ver a semana desta campanha.',
    'chart.noReading': 'Nenhuma visualização lida nos últimos 7 dias.',
  },
  {
    'section.campaigns': 'Campaigns',
    'card.noWindow': 'No period set',
    'card.window': '{from} – {to}',
    'empty.title': 'No campaigns yet',
    'empty.body': 'A campaign holds the accounts you want to follow.',
    'counts.line': '{campaigns} · {members}',
    'counts.campaigns.other': '{count} campaigns',
    'counts.campaigns.one': '{count} campaign',
    'counts.members.other': '{count} people with access',
    'counts.members.one': '{count} person with access',
    'newCampaign.noSlot': 'No free slot for a new campaign.',
    'status.collecting': 'Collecting',
    'status.paused': 'Paused',
    'status.archived': 'Ended',
    'filter.label': 'Filter campaigns by status',
    'filter.all': 'All',
    'filter.empty': 'No campaign in this status.',
    'figure.accounts': 'Tracked accounts',
    'figure.reach': 'Reach · 7d',
    'figure.posts': 'Posts · 7d',
    'chart.label': 'Views per day over the last 7 days',
    'chart.views': 'Views',
    'chart.posts': 'Posts',
    'chart.noAccounts': "Add accounts to see this campaign's week.",
    'chart.noReading': 'No views read in the last 7 days.',
  },
);
export const hm = homeCatalogue.t;
export const hmPlural = homeCatalogue.plural;
